(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('IntegrationDeleteDialogController',IntegrationDeleteDialogController);

    IntegrationDeleteDialogController.$inject = ['$uibModalInstance', 'entity', 'Integration'];

    function IntegrationDeleteDialogController($uibModalInstance, entity, Integration) {
        var vm = this;
        vm.client = entity;

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirmDelete = function (id) {
            Integration.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
